import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CharacteristicConsultService } from 'src/app/pages/register/characteristic-consult/services/characteristic-consult.service';
import { CarbonOperation } from 'src/app/shared/interfaces/carbon-operation';

import {
  mapTransferDetailsToView,
  OperationTransferDetailsView,
} from '../shared/operation-transfer-details.utils';
import {
  OperationTypeBadge,
  resolveOperationTypeBadge,
} from '../shared/operation-type-badge.utils';

@Component({
  standalone: false,
  selector: 'app-operation-transfer-details-drawer',
  templateUrl: './operation-transfer-details-drawer.component.html',
  styleUrls: ['./operation-transfer-details-drawer.component.scss'],
})
export class OperationTransferDetailsDrawerComponent implements OnChanges {
  @Input() open = false;
  @Input() operation: CarbonOperation | null = null;
  @Output() openChange = new EventEmitter<boolean>();

  details: OperationTransferDetailsView | null = null;
  isLoading = false;

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['open'] || changes['operation']) && this.open && this.operation) {
      this.loadDetails(this.operation);
    }

    if (changes['open'] && !this.open) {
      this.details = null;
    }
  }

  get operationTypeBadge(): OperationTypeBadge {
    return this.operation ? resolveOperationTypeBadge(this.operation) : {
      label: 'Transferência',
      icon: 'swap_horiz',
      tone: 'warning',
    };
  }

  close(): void {
    this.open = false;
    this.openChange.emit(false);
  }

  constructor(
    private readonly characteristicConsultService: CharacteristicConsultService,
  ) {}

  private loadDetails(operation: CarbonOperation): void {
    const carbonCreditCode = operation.carbonCreditCode?.trim();

    if (!carbonCreditCode) {
      this.details = mapTransferDetailsToView(operation);
      this.isLoading = false;
      return;
    }

    this.isLoading = true;

    this.characteristicConsultService.getCarbonCreditById(carbonCreditCode).subscribe({
      next: (carbonCredit) => {
        this.details = mapTransferDetailsToView(operation, carbonCredit);
        this.isLoading = false;
      },
      error: () => {
        this.details = mapTransferDetailsToView(operation);
        this.isLoading = false;
      },
    });
  }
}
